import React, { useEffect, useState } from 'react';
import { addSpace } from '../../Components/Tools';
import ApexCharts from 'react-apexcharts';
import axios from 'axios';
import qs from 'qs';

function PortageEtEndettement(props)
{
    const [series, setSeries] = useState(undefined)
    const [options, setOptions] = useState(undefined)

    useEffect(() => {
        mount();
    }, [])


    async function mount() {

        var filename = "";
        var annees = [];
        var deb = props.user.config_budget.retro_an_deb;
        var fin = props.user.config_budget.prosp_an_fin;
        for(var an=deb; an<=fin; an++){
            annees.push(an);
        }

        /* Initialisation des options avec les années */
        var option_tmp = {
            chart: {
                toolbar: {
                    show: props.download?true:false,
                    export: {
                        svg: {
                          filename: filename.replace("'", '_').replace("/", '_').replace(".", ''),
                        },
                        png: {
                          filename: filename.replace("'", '_').replace("/", '_').replace(".", ''),
                        },
                        csv: {
                          filename: filename.replace("'", '_').replace("/", '_').replace(".", ''),
                        },
                    },
                },
                type: 'bar',
                height: 350,
            },
            title: {
                text: filename
            },
            xaxis: {
                categories: annees
            },
            yaxis: {
                labels: {
                  formatter: function (value) {
                    return addSpace(Math.round(value*100)/100, true)+' €';
                  }
                },
            },
            dataLabels: {
                formatter: (e) => {
                    return addSpace(Math.round(e/1000), true)+' k';
                }
            },
            plotOptions: {
                bar: {
                    borderRadius: 4
                },
            },
            fill: {
              opacity: 1
            }
        }
        await setOptions(option_tmp)
        
        await axios.post('https://app-slfinance.fr/api/graph.php', qs.stringify({
            'EPFL_PortageEtEndettement': true,
            'id_budget': props.user.id_budget,
            'retro_an_deb': props.user.config_budget.retro_an_deb,
            'retro_an_fin': props.user.config_budget.retro_an_fin,
            'prosp_an_deb': props.user.config_budget.prosp_an_deb,
            'prosp_an_fin': props.user.config_budget.prosp_an_fin,
            'hypothese': props.hypothese,
            'nomen': props.user.nomen
        }))
        .then(async (res) => {
            await setSeries([{
                name: 'Portage (compte 312)',
                data: res.data[0],
                color: '#015fda',
                type: 'bar',
            },
            {
                name: 'Endettement au 31/12',
                data: res.data[1],
                color: '#d664d6',
                type: 'bar',
            }])
        })
    }


	return (
		<div style={{margin: 5}}>
            {options && series?
			<ApexCharts
                series={series}
                options={options}
                width={'100%'}
                height={props.height?props.height:400}
                type="bar"
            />:null}
		</div>
	)
}

export default PortageEtEndettement;
